export const API_VERSION = 'v1';
export const BASE_API_ENDPOINT = `${process.env.MIX_HTTP_PROTOCOL}://www.${process.env.MIX_ROOT_DOMAIN}`;
export const BASE_API_PATH = `/api/${API_VERSION}/admin`;
export const BASE_API_URL = `${BASE_API_ENDPOINT}${BASE_API_PATH}`;

export const BASE_WEB_ENDPOINT = `${process.env.MIX_HTTP_PROTOCOL}://api.${process.env.MIX_ROOT_DOMAIN}`;
export const BASE_WEB_PATH = `/admin`;
export const BASE_WEB_URL = `${BASE_WEB_ENDPOINT}${BASE_WEB_PATH}`;
